import { render, staticRenderFns } from "./viewBlockLeavePolicy.vue?vue&type=template&id=bfd7b7e6&"
import script from "./viewBlockLeavePolicy.vue?vue&type=script&lang=js&"
export * from "./viewBlockLeavePolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VContainer,VForm,VRow,VSheet})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfd7b7e6')) {
      api.createRecord('bfd7b7e6', component.options)
    } else {
      api.reload('bfd7b7e6', component.options)
    }
    module.hot.accept("./viewBlockLeavePolicy.vue?vue&type=template&id=bfd7b7e6&", function () {
      api.rerender('bfd7b7e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/BlockLeave/BlockLeavePolicy/viewBlockLeavePolicy.vue"
export default component.exports